export class GetMicroWorkOrdersResponse {
  SuccessCount: number;
  InFlightCount: number;
  FailCount: number;
}
